import { useDrag } from "react-dnd";

const Trophy = ({ id, isAssigned, onDragEnd, label }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "TROPHY",
      item: { id },
      collect: (monitor) => ({
        isDragging: !!monitor.isDragging(),
      }),
      canDrag: !isAssigned,
      end: (item, monitor) => {
        if (monitor.didDrop()) {
          onDragEnd(item, monitor);
        }
      },
      delay: 0,
    }),
    [id, isAssigned, onDragEnd]
  );

  const style = {
    opacity: isDragging ? 0.5 : 1,
    cursor: isAssigned ? "default" : "pointer",
    touchAction: "none",
    position: "relative",
    userSelect: "none",
  };

  const getBoxColor = (id) => {
    switch (id) {
      case "cleanliness":
        return "!bg-green-200/20 !border-green-400";
      case "reliability":
        return "!bg-blue-200/20 !border-blue-400";
      case "fun":
        return "!bg-orange-200/20 !border-orange-400";
      default:
        return "";
    }
  };

  return (
    <div
      ref={drag}
      style={style}
      className={`bg-white text-white p-2 rounded shadow ${
        !isAssigned ? "cursor-pointer" : ""
      } w-[56px] h-[56px] flex items-center justify-center border border-white overflow-hidden ${
        isAssigned && label ? getBoxColor(label) : ""
      }`}
    >
      <span className="text-yellow-500 text-3xl self-center mx-auto">🏆</span>
    </div>
  );
};

export default Trophy;
